import { Col } from 'antd';

const TrailerActions = ({ isModal, OpenReportPopup, OpenTrailerPopup, OpenUpdateTrailerPopup }) => {
  return (
    <>
      {!isModal && (
        <>
          <Col className="mt-25">
            <button type="button" className="btn btn-dipblue" onClick={OpenReportPopup}>
              Report an Issue
            </button>
          </Col>

          <Col className="mt-25">
            <button type="button" onClick={() => OpenTrailerPopup('add')} className="btn btn-dipblue">
              Add a New Trailer
            </button>
          </Col>

          <Col className="mt-25">
            <button type="button" onClick={() => OpenUpdateTrailerPopup('update')} className="btn btn-dipblue">
              Update Trailer
            </button>
          </Col>
        </>
      )}
    </>
  );
};

export default TrailerActions;
